module.exports = __webpack_public_path__ + "static/img/cybg_banner.56ac010.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cybg_banner.png
// module id = mfl0
// module chunks = 1